/*=========================================================================================
  File Name: modulePartnerMutations.js
  Description: Partner Module Mutations
==========================================================================================*/


export default {
    SET_PROGRAM_SEARCH_QUERY(state, query) {
        state.programSearchQuery = query
    },
    UPDATE_PROGRAM_FILTER(state, filter) {
      state.programFilter = filter
    },

    // API
    CREATE_PARTNER(state, data) {
      state.partners.push(data)
    },
    UPDATE_PARTNER(state, data) {
      Object.assign(state.partner, data)
    },
    UPDATE_PARTNER_STATE(state, data) {
      state.partner.state = data
    },
    UPDATE_PARTNER_PROGRAM(state, data) {
      state.partner.program = data
    },
    DELETE_PARTNER(state, data) {
      const index = state.partners.findIndex((t) => t.partid == data.partid)
      state.partners.splice(index, 1);
    },
    SET_PARTNER(state, data) {
      state.partner = data
    },
    SET_PARTNERS(state, data) {
      state.partners = data
    },
    
    SET_PROGRAMS(state, data) {
      state.programs = data
    },
    ADD_PROGRAM(state, data) {
      state.programs.push(data)
    },
    UPDATE_PROGRAM(state, data) {
      const index = state.programs.findIndex((t) => t.ppid == data.ppid)
      Object.assign(state.programs[index], data)
    },
    DELETE_PROGRAM(state, data) {
      const index = state.programs.findIndex((t) => t.ppid == data.ppid)
      state.programs.splice(index, 1);
    },
    
    SET_DEVICES(state, data) {
      state.devices = data
    },
    ADD_DEVICE(state, data) {
      state.devices.push(data)
    },
    UPDATE_DEVICE(state, data) {
      const index = state.devices.findIndex((t) => t.ppid == data.ppid)
      Object.assign(state.devices[index], data)
    },
    DELETE_DEVICES(state, data) {
      data.forEach((data_value) => {
        state.devices.forEach((devices_value, index) => {
          if (data_value.pdid === devices_value.pdid) {
            state.devices.splice(index, 1);
            return false;
          }
        })
      })
    },
}
